export default function getCodeFromQueryString(param = 'lang') {
  const params = (new URL(document.location)).searchParams;
  const langFromQuery = params.get(param);
  return langFromQuery;
}
